module.exports = __webpack_public_path__ + "static/mockupPhoneNew@2x-79478d4de2201e4c54f191265793760d.png";